module.exports = __webpack_public_path__ + "static/media/menu-icon-legacy-locked.265bc57c.png";